import ApiRoute from '../../../components/ApiRoute'

const Health = ({ callApiFn, isApiCalling }) => {
  const getHealth = () => {
    callApiFn({
      method: 'GET',
      route: '/healthConditions'
    })
  }

  return (
    <div>
      <ApiRoute method='GET' route='/healthConditions' onClick={getHealth} disabled={isApiCalling} />
    </div>
  )
}

export default Health
